<template>

  <div>
    <div
      v-if="creatingCriteria"
      class="text-muted">
      <div class="spinner-border mr-1" style="width: 1.2rem; height: 1.2rem;"></div>
      Gerando critérios de busca...
    </div>
    <form
      v-else
      v-on:submit.prevent="submit">
      <div
        v-if="changeReason"
        class="alert alert-info alert-dismissible p-3"
        role="alert">
        {{ changeReason }}
        <button
          type="button"
          class="btn btn-sm btn-primary mt-2 d-block"
          @click="closeChangeReason">
          Ok
        </button>
      </div>

      <div class="d-flex justify-content-between mb-3">
        <div>
          <h5>{{ $t('Texto de pesquisa') }}</h5>
        </div>
        <div class="dropdown">
          <button
            class="btn btn-sm btn-light dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <i class="fas fa-cog"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" href="javascript:void(0)" @click="redefineCriteria">Redefinir critérios</a>
          </div>
        </div>
      </div>
      <p class="text-muted">Descreva o perfil como se estivesse escrevendo um currículo ideal. Cargo, senioridade, localização, tecnologias e contexto da empresa.</p>
      <div class="form-group">
        <textarea-autosize
          v-model="value.query"
          :min-height="60"
          class="form-control"
          :disabled="isRunning">
          </textarea-autosize>
        <ValidateMessage :error="validateErrors.query" />
      </div>

      <h5 class="mt-4">{{ $t('Critérios') }}</h5>
      <p class="text-muted">Cada perfil encontrado será avaliado contra esses critérios. Use apenas o que for obrigatório.</p>

      <div
        v-for="(criteria, index) in criterias"
        :key="index"
        class="mb-3">
        <div
          class="card">
          <div class="card-header">
            <div><b>{{ $t(criteria.label) }}</b></div>
            <div class="text-muted">{{ $t(criteria.placeholder) }}</div>
          </div>
          <textarea-autosize
            v-model="value.criteria[criteria.id]"
            :min-height="60"
            class="form-control"
            :disabled="isRunning"
            style="border: none;">
            </textarea-autosize>
        </div>
        <ValidateMessage :error="validateErrors[`criteria.${criteria.id}`]" />
      </div>

      <div
        class="form-group">
        <label><b>{{ $t('Quantidade de perfis') }}</b></label>
        <div>
          <div class="btn-group" disabled>
            <button
              type="button"
              class="btn btn-outline-secondary"
              :class="{ active: value.count === 5 }"
              @click="value.count = 5"
              :disabled="isRunning">
              5
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary"
              :class="{ active: value.count === 10 }"
              @click="value.count = 10"
              :disabled="isRunning">
              10
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary"
              :class="{ active: value.count === 20 }"
              @click="value.count = 20"
              :disabled="isRunning">
              20
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary"
              :class="{ active: value.count === 50 }"
              @click="value.count = 50"
              :disabled="isRunning">
              50
            </button>
          </div>
          <ValidateMessage :error="validateErrors.count" />
        </div>
      </div>

      <div class="form-group">
        <div class="form-check mb-2">
          <input
            type="checkbox"
            class="form-check-input"
            id="autoAdjust"
            v-model="value.auto_adjust_enabled"
            :disabled="isRunning">
          <label class="form-check-label" for="autoAdjust">
            <b>{{ $t('Ajuste automático') }}</b>
          </label>
        </div>
        <ValidateMessage :error="validateErrors.auto_adjust_enabled" />
        <p>Com o ajuste automático ativado, o Seeker ajusta os critérios quando necessário para encontrar os perfis solicitados.</p>
      </div>

      <div>
        <div
          v-if="errorMessage"
          class="alert alert-danger mb-3">
          {{ errorMessage }}
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-md"
          :disabled="isRunning">
          {{ $t('Search') }}
        </button>
      </div>
    </form>
  </div>

</template>

<script>
import _ from 'lodash'

export default {
  name: 'JobSeekerForm',
  components: {
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    isRunning: {
      type: Boolean,
      default: false
    },
    creatingCriteria: {
      type: Boolean,
      default: false
    },
    changeReason: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    validateErrors: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      value: {}
    }
  },
  watch: {
    modelValue: {
      handler (newValue) {
        this.value = _.cloneDeep(newValue)
      },
      immediate: true
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    criterias () {
      return [
        { id: 0, label: 'Critério 1', placeholder: 'Senioridade, experiência e atuação' },
        { id: 1, label: 'Critério 2', placeholder: 'Hard skills, idiomas e responsabilidades' },
        { id: 2, label: 'Critério 3', placeholder: 'Setor, contexto e empresa' },
        { id: 3, label: 'Critério 4', placeholder: 'Formação, certificações e instituições' },
        { id: 4, label: 'Critério 5', placeholder: 'Localização' }
      ]
    }
  },
  created () {
  },
  methods: {
    submit () {
      this.$emit('submit', this.value)
    },
    closeChangeReason () {
      this.$emit('closeChangeReason')
    },
    redefineCriteria () {
      this.$emit('redefineCriteria', {
        type: 'from_job'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobSeeker/JobSeekerForm.vue